// src/components/OtSelect/ModalController.jsx
import React from 'react';
import { Modales } from '../Modales';
import { Observacioneq } from '../Equipo/Observacioneq';
import { Otdatacliente } from '../Ot/Otdatacliente';
import { Otsonpdf } from '../Ot/Otsonpdf';
import { AddItems } from '../Ot/AddItems';
import { HojasDeTrabajo } from '../Seguimiento/HojasTrabajo';
import { EqFinalizadosTotal } from '../Ot/EqFinalizados';
import { Canceleq } from '../Equipo/Canceleq';
import { Editareq } from '../Equipo/Editareq';



const ModalController = ({ accion, estadomodal, setEstadomodal, equipoinfo, ots, handlers, propsExtra, programData }) => {

return (
<Modales estado={estadomodal} cambiarestado={setEstadomodal} titulo={`${accion.tarea} : ${accion.titulo}`}>
<div>
{ accion.tarea === 'Editar' && <Editareq infoOt={ots} refrescar={handlers.toggleRefresh} refresh={propsExtra.refresh} infoequipo={equipoinfo} cambiarestado={setEstadomodal} setEquiposOtIni={propsExtra.setEquiposOtIni} /> }
{ accion.tarea === 'Cancelar' && <Canceleq infoOt={ots} cambiarestado={setEstadomodal} iditem={equipoinfo._id} setEquiposOtIni={propsExtra.setEquiposOtIni} refresh={propsExtra.refresh} setRefresh={handlers.toggleRefresh}/> }
{ accion.tarea === 'Editar Cliente' && <Otdatacliente infocliente={ots?.cliente} cambiarestado={setEstadomodal} refrescar={handlers.toggleRefresh} refresh={propsExtra.refresh} /> }
{ accion.tarea === 'Hoja de Trabajo' && <Otsonpdf mode="programacion" otFath={programData} programData={programData} EqSedeFilter={propsExtra.EqSedeFilter} cambiarestado={setEstadomodal} setRefresh={handlers.toggleRefresh} refresh={null} sitioSeleted={propsExtra.sitioSeleted} sedeSeleted={propsExtra.sedeSeleted} sedes={propsExtra.sedes} SetModalcharge={propsExtra.SetModalcharge} /> }
{ accion.tarea === 'Observacion' && <Observacioneq cambiarestado={setEstadomodal} infoobservacion={equipoinfo?.observacion} /> }
{ accion.tarea === "Adicionar Ítems" && <AddItems setEstadoModal={setEstadomodal} idOt={ots?._id} ot={ots} setRefresh={propsExtra.setRefresh} refresh={propsExtra.refresh} cliente={ots?.cliente} sedeSeleted={propsExtra.sedeSeleted} sedes={propsExtra.sedes} SetModalcharge={propsExtra.SetModalcharge} historialeq={propsExtra.historialeq} setHistorialEq={propsExtra.setHistorialEq}/> }
{ /* NOTA: "Hojas de Trabajo" legacy - OtSelectMain, Otselect y OtSelectTwo usan ModalHojasTrabajo directamente */ }
{ accion.tarea === "Hojas de Trabajo" && <HojasDeTrabajo setEstadoModal={setEstadomodal} orden={ots?.numeroOrden} setRefresh={propsExtra.setRefresh} refresh={propsExtra.refresh} /> }
{ accion.tarea === "Equipos Finalizados" && <EqFinalizadosTotal setEstadoModal={setEstadomodal} ot={programData || ots} setRefresh={propsExtra.setRefresh} refresh={propsExtra.refresh} /> }
</div>
</Modales>
);
};


export default ModalController;